<template>
  <b-container class="site-detail__reportsettings contentcontainer">
    <b-row class="contentcontainer__head">
      <b-col>
        <h2>{{$t('config.settingsmonitoring')}}</h2>
      </b-col>
      <b-col>
        <div class="actions">
          <button class="btn btn--success" v-on:click="save">
              <span class="btn__icon">
                  <font-awesome-icon class="icon" :icon="['fal','save']"></font-awesome-icon>
              </span>
            {{$t('config.save')}}
          </button>
        </div>
      </b-col>
    </b-row>
    <hr/>
    <b-row>
      <b-col>
        <b-form-group :label="$t('config.downtimetolerance')">
          <b-input-group append="minutes">
            <b-form-input
              v-model="inputValue"
              type="text"
              :placeholder="`${accountTolerance} (${$t('site.globalsetting')})`"
              id="downtimeTolerance"
            >
            </b-form-input>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'

import mixins from '../../mixins'

export default {

  name: 'SiteDetailSettingsMonitoring',

  mixins: [mixins],

  computed: {

    ...mapState('site', [
      'siteDetail'
    ]),

    ...mapGetters('user', {
      account: 'getAccount'
    }),

    accountTolerance () {
      if (this.account.config && this.account.config.downtime_tolerance) {
        return this.account.config.downtime_tolerance
      }

      return 3
    }
  },

  data () {
    return {
      storageValue: -1,
      inputValue: ''
    }
  },

  watch: {
    'siteDetail': function () {
      this.preparePage()
    },
    'inputValue': function () {
      if (this.inputValue !== '') {
        this.storageValue = this.inputValue

        return
      }

      this.storageValue = -1
    }
  },

  methods: {

    ...mapMutations('site', [
      'closeSiteDetailPageConfiguration'
    ]),

    ...mapActions('site', [
      'saveSiteConfiguration'
    ]),

    ...mapActions('user', [
      'getAccount'
    ]),

    preparePage () {
      this.storageValue = this.getConfigValue(
        this.siteDetail.data.configuration,
        'downtime_tolerance',
        -1
      )

      if (this.storageValue > -1) {
        this.inputValue = this.storageValue

        return
      }

      this.inputValue = ''
    },

    save () {
      let payload = {
        id: this.siteDetail.id,
        configuration: {
          'downtime_tolerance': this.storageValue
        }
      }

      this.saveSiteConfiguration(payload)
    }
  },

  mounted () {
    this.getAccount()
  }
}
</script>
